export default function isHighRisk(riskPoints: number): boolean {
  return riskPoints >= 10;
}
